import { forwardRef } from 'react';
import { Input, InputProps } from './Input';

interface DateInputProps extends Omit<InputProps, 'type'> {
  loading?: boolean;
}

export const DateInput = forwardRef<HTMLInputElement, DateInputProps>(
  ({ loading = false, ...props }, ref) => {
    return (
      <Input
        ref={ref}
        type="date"
        loading={loading}
        {...props}
      />
    );
  }
);

DateInput.displayName = 'DateInput';